import { Box, Typography } from '@mui/material';
import emptyImg from 'src/pages/therapist-dashboard/therapist-document/image-removebg-preview.png';

interface DocumentTableEndMessageProps {
  totalDocuments: number;
}

export const DocumentTableEndMessage = ({ totalDocuments }: DocumentTableEndMessageProps) => {
  return (
    <Box
      textAlign="center"
      p={3}
    >
      {totalDocuments === 0 && (
        <Box>
          <img
            src={emptyImg}
            alt="No results"
            style={{
              width: 720,
              height: 300,
              margin: 'auto',
              alignItems: 'center',
              alignContent: 'center',
              marginTop: 100,
              display: 'block',
            }}
          />
          <Typography
            color="text.secondary"
            variant="h5"
            fontWeight="200"
          >
            No results found
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default DocumentTableEndMessage;
